function formatDateTime(dateString, type = "fulltime") {
  if (!dateString) return "-";

  const date = new Date(dateString);

  const formats = {
    fulltime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    },
    date: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "2-digit",
      minute: "2-digit",
    },
  };

  return date.toLocaleString("es-CO", formats[type] || formats.fulltime);
}

export { formatDateTime };
